import { render, staticRenderFns } from "./MembershipEventDetails.vue?vue&type=template&id=627cf6ca"
import script from "./MembershipEventDetails.vue?vue&type=script&lang=js"
export * from "./MembershipEventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports